import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import ZiyuanPage from "../pages/ziyuan/page";
import AppPage from "../pages/app/page";
import TuijianPage from "../pages/tuijian/page";
import ArticleListPage from "../pages/article/page";
import ArticleDetail from "../pages/article/detail";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "ziyuan", element: <ZiyuanPage /> },
      { path: "app", element: <AppPage /> },
      { path: "tuijian", element: <TuijianPage /> },
      { path: "article", element: <ArticleListPage /> },
      { path: "article/:id", element: <ArticleDetail /> },
      { path: "faq", element: <FaqPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;